import gsap from "gsap"
import DrawSVGPlugin from "gsap/DrawSVGPlugin"
import { Flip } from "gsap/Flip"
// import { GSDevTools } from "gsap/GSDevTools"
import MorphSVGPlugin from "gsap/MorphSVGPlugin"
import { ScrollSmoother } from "gsap/ScrollSmoother"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { SplitText } from "gsap/SplitText"
import TextPlugin from "gsap/TextPlugin"

gsap.registerPlugin(
    ScrollTrigger,
    ScrollSmoother,
    DrawSVGPlugin,
    TextPlugin,
    SplitText,
    Flip,
    MorphSVGPlugin,
    ScrollToPlugin,
);

// const smooth = ScrollSmoother.create({
// smooth: 1,
// effects: false, // Enables data-speed and data-lag attributes
// smoothTouch: 1,
// });
// ScrollTrigger.normalizeScroll(true)

export default gsap;

export {
    Flip, gsap,
    ScrollSmoother, ScrollTrigger, SplitText
}

export function useGSAP() {
    return {
        gsap,
        GSDevTools,
        SplitText,
        ScrollSmoother,
        ScrollTrigger,
        Flip,

    }
}
